import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/anime';

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  const goPrev = () => setIndex((prev) => (prev - 1 + banners.length) % banners.length);
  const goNext = () => setIndex((prev) => (prev + 1) % banners.length);
  const active = banners[index];

  return (
    <section className="relative w-full h-[560px] md:h-[640px] overflow-hidden bg-primary-950">
      {banners.map((banner, i) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={banner.image}
            alt={`${banner.title}焦点海报`}
            title={`${banner.title}在线观看`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/40"></div>
        </div>
      ))}

      <div className="relative w-full h-full flex items-center">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-2xl pt-16">
            <h1 className="font-heading text-sm md:text-base font-semibold tracking-wide text-accent-400 mb-4">
              动漫在线观看
            </h1>
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs bg-secondary-500 text-secondary-950 font-semibold mb-4">
              <i className="ri-fire-fill"></i>
              {active.tag}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 animate-fade-up">
              {active.title}
            </h2>
            <p className="text-sm md:text-base text-background-100/90 mb-8 leading-relaxed max-w-xl animate-fade-up">
              {active.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Link
                to={`/detail/${active.animeId}`}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 font-medium whitespace-nowrap cursor-pointer transition-colors"
              >
                <i className="ri-play-fill text-lg"></i>
                立即观看
              </Link>
              <Link
                to="/category/少年"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium whitespace-nowrap cursor-pointer border border-background-50/40 transition-colors"
              >
                <i className="ri-layout-grid-line"></i>
                浏览分类
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {banners.map((banner, i) => (
          <button
            key={banner.id}
            type="button"
            onClick={() => setIndex(i)}
            aria-label={`切换到第${i + 1}张`}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? 'w-8 bg-accent-500' : 'w-3 bg-background-50/50 hover:bg-background-50/80'
            }`}
          ></button>
        ))}
      </div>

      <div className="hidden md:flex absolute bottom-6 right-6 items-center gap-2 z-10">
        <button
          type="button"
          onClick={goPrev}
          aria-label="上一张"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/30 text-background-50 cursor-pointer border border-background-50/30 transition-colors"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          onClick={goNext}
          aria-label="下一张"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/30 text-background-50 cursor-pointer border border-background-50/30 transition-colors"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>
      </div>
    </section>
  );
}